module.exports = __webpack_public_path__ + "img/delivered.cbf09a01.png";